<template>
  <component
    :is="filterComponent"
    v-bind="$props"
    @filter-selected="$emit('filter-selected', { item, value: $event })"
  ></component>
</template>

<script>
import FilterItemWithCategories from '@/components/pages/filter/categories/FilterItemWithCategories'
import FilterItemCheckbox from '@/components/pages/filter/checkbox/FilterItemCheckbox'
import FilterItemRadio from '@/components/pages/filter/radio/FilterItemRadio'

export default {
  components: {
    'c-filter-item-with-categories': FilterItemWithCategories,
    'c-filter-item-checkbox': FilterItemCheckbox,
    'c-filter-item-radio': FilterItemRadio,
  },
  props: { item: { required: true, type: Object }, loading: Boolean, showChevron: Boolean },
  computed: {
    filterComponent() {
      const { categories, radio } = this.item
      if (categories) return 'c-filter-item-with-categories'
      else if (radio) return 'c-filter-item-radio'
      else return 'c-filter-item-checkbox'
    },
  },
}
</script>
